/**
 * plugins
 *
 * @author Shigq
 * @date 2021/11/10 10:53
 */

import '@/config/permission'
import installI18n from './i18n'
import installGeeTest from './gee-test'
import installElementPlus from './element-plus'

export default app => {
  // i18n
  installI18n(app)
  installGeeTest(app)
  // element plus
  installElementPlus(app)
}
